import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Mailto from 'react-mailto';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../constants/contacts';
import {isLoggedIn, getGuestCart, saveGuestCart} from '../../../utils/auth';

import {MenuContainer} from '../menu/Menu';
import {MobileMenuContainer} from '../menu/MobileMenu';
import {LoginContainer} from '../login/Login';
import {RegisterContainer} from '../login/Register';
import EarringAlert from '../../common/alert/EarringAlert';

import * as cartActionCreators from '../../../actions/cart';
import * as commonActionCreators from '../../../actions/common';
import * as headerActionCreators from '../../../actions/header';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, cartActionCreators, commonActionCreators, headerActionCreators, userActionCreators);



class Header extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      searchOpen: false,
      searchValue: '', 
      scrollPos: 0,
      earringOpen: false,
      displayRegister: false,
      cartCount: null,
    };

    // console.log(getGuestCart());
    // if(!getGuestCart()) {
    //   this.props.cartGuestCartId()
    //   .then((response) => {
    //     console.log(response);
    //     saveGuestCart(response);
    //   });
    // }

    // if(isLoggedIn()) {
      this.props.cartLoggedInItems()
      .then((response) => {

        let respObj = JSON.parse(response);

        if(respObj && respObj.success) {
          this.setState({ cartCount: parseInt(respObj.success.qty) });
        }
      });
    // }

    // Bind event listeners
    this.getScrollPos = ::this.getScrollPos;
    this.checkLoginClick = ::this.checkLoginClick;
    this.checkSliver = ::this.checkSliver;
  }

  componentDidMount() {
    document.addEventListener('click', this.checkLoginClick, false);
    window.addEventListener('scroll', this.getScrollPos, false);

    this.checkId = setInterval(this.checkSliver, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    // if(prevProps.loginOpen === false && this.props.common.loginOpen === true) {

    // }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkLoginClick, false);
    window.removeEventListener('scroll', this.getScrollPos, false);

    clearInterval(this.checkId);
  }

  checkSliver() {
    if(this.firstSliver && window.location.href && window.location.href.includes('/gallery/')) {
      this.firstSliver.style.display = 'flex';
    } else {
      if(this.firstSliver) {
        this.firstSliver.style.display = 'none';
      }
    }
    // if(this.secondSliver && window.location.href && window.location.href.includes('new-orleans')) {
    //   this.secondSliver.style.display = 'flex';
    // } else {
    //   if(this.secondSliver) {
    //     this.secondSliver.style.display = 'none';
    //   }
    // }
    this.secondSliver.style.display = 'none';
  }

  checkLoginClick(evt) {

    if(window.innerWidth <= 1024) {
      return;
    }

    if((window.innerWidth - evt.clientX) <= 360 && evt.clientY < 50) {
      return;
    }

    if(this.props.common.loginOpen === true) {
      let targetElement = evt.target;

      do {
        if(targetElement.className == 'loginInnerWrapper') {
          return;
        }

        if(targetElement == this.loginBody) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close

      // TODO add a timestamp so can't close instantaniously after opening

      // this.props.commonCloseLogin();
    }
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    })
  }

  homeNav() {
    this.context.router.push('/');
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  giftGuideNav() {
    window.location.href = 'https://gifts.diamondsdirect.com';
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  toggleSearch() {
    this.setState({ searchOpen: !this.state.searchOpen });
  }

  changeSearch(evt) {
    this.setState({
      searchValue: evt.target.value,
    })
  }

  keyPressSearch(evt) {
    if(evt.key === 'Enter') {
      this.submitSearch();
    }
  }

  submitSearch() {
    if(this.state.searchValue !== '') {
      this.userNav('diamonds-direct-search?p=init&q=' + this.state.searchValue);
      this.setState({
        searchOpen: false,
      }, () => {
        setTimeout(() => {
          this.setState({ searchValue: '' });
        }, 500);
      });
    }
  }

  getHeaderClass() {
    return this.state.scrollPos > 30 ? 'Header following' : 'Header';
  }

  openIntercom() {
    acquireIO.max();
  }

  openContact() {
    // this.props.commonOpenContact();
    this.internalNav('contact-us');
  }

  openEarringAlert() {
    this.setState({ earringOpen: true }, () => {
      console.log(this.state)
    });
  }

  closeEarringAlert() {
    this.setState({ earringOpen: false });
  }

  openLogin() {
    this.props.commonOpenLogin();
  }

  toggleLoginType() {
    console.log('toggly toggle');
    this.setState({ displayRegister: !this.state.displayRegister });
  }

  render() {
    return <div className={this.getHeaderClass()}>
      <MenuContainer />
      <MobileMenuContainer />
      <div 
        className={this.props.common.loginOpen ? 'loginWrapper open' : 'loginWrapper'} ref={(div) => { this.loginBody = div; }}>
        {this.state.displayRegister ?
          <RegisterContainer toggleMethod={::this.toggleLoginType} /> :
          <LoginContainer toggleMethod={::this.toggleLoginType} />
        }
      </div>
      <div className='lhs'>
        <div className={'menuWrapper desktop1024'} onClick={::this.props.headerToggle}></div>
        <div className={'mobileMenu mobile1024'} onClick={::this.props.headerToggle}>
          <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/header/mobile-menu.svg' alt='Menu' />
        </div>
      </div>
      <div className='centerIcon' onClick={::this.homeNav}>
        <div className='iconWrapper iconNoFollow'>
          <LazyLoadImage className='desktopIcon' src='https://ddw2.diamondsdirect.com/img/header/ddlogo.svg' alt='Diamonds Direct Logo'  />
          <LazyLoadImage className='mobileIcon' src='https://ddw2.diamondsdirect.com/img/header/ddicon.svg' alt='Diamonds Direct Logo'  />
        </div>
        <div className={'iconWrapper iconFollow'}>
          <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/header/ddicon.svg' alt='Diamonds Direct Logo' />
        </div>
      </div>
      <div className='rhs'>
        <div className={'smallLinkWrapper desktop1024'}>
          <div className='smallLink' onClick={::this.openContact}>Contact Us</div>
          <div className='smallLink' onClick={() => this.internalNav('financing')}>Financing</div>
          <div className='smallLink' onClick={() => this.internalNav('locations')} style={{ display: 'none' }}>Locate a Store</div>
          <div className='smallLink' onClick={() => this.internalNav('frequently-asked-questions')}>FAQ</div>
          <div className={'smallLink headerChat'} onClick={::this.openIntercom}>Chat</div>
        </div>
        <div className={'iconLinkWrapper desktop1024'}>
          <div className='iconLink' onClick={() => this.userNav('checkout/cart')}>
            <div className={'iconImg cartImg'}>
              <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/header/cart.svg' alt='Shopping cart' />
              {this.state.cartCount ?
                <div className='cartBubble'><div>{this.state.cartCount}</div></div> :
                null
              }
            </div>
            <div className='iconLabel'>Cart</div>
          </div>
          {isLoggedIn() ?
            <div className='iconLink' onClick={() => this.internalNav('account')}>
              <div className='iconImg'>
                <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/header/account.svg' alt='Account' />
              </div>
              <div className='iconLabel'>My Account</div>
            </div> :
            <div className='iconLink' onClick={::this.openLogin}>
              <div className='iconImg'>
                <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/header/account.svg' alt='Account' />
              </div>
              <div className='iconLabel'>Log In</div>
            </div>
          }
          <div className='iconLink' onClick={::this.toggleSearch}>
            <div className='iconImg'>
              <i className="fas fa-search"></i>
            </div>
            <div className='iconLabel'>Search</div>
          </div>
          <div className='iconLink' onClick={::this.openIntercom} style={{ display: 'none' }}>
            <div className='iconImg'>
              <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/header/chat.svg' alt='Chat' />
            </div>
            <div className='iconLabel'>Chat</div>
          </div>
          <div className='ggLink' onClick={::this.giftGuideNav}></div>
        </div>
        <div className={'giftIcon mobile1024'} onClick={::this.giftGuideNav}>
          <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/header/gift-guide/gg_box.svg' alt='Gift Guide' />
        </div>
        <div className={'giftIcon mobile1024 mobileThird'} onClick={::this.toggleSearch}>
          <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/header/glass.png' alt='Search Diamonds Direct' />
        </div>

        {isLoggedIn() ?
          <div className={'giftIcon mobile1024'} onClick={() => this.internalNav('account')} style={{ display: 'none' }}>
            <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/header/account.svg' alt='Account' />
          </div> :
          <div className={'giftIcon mobile1024'} onClick={::this.openLogin} style={{ display: 'none' }}>
            <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/header/account.svg' alt='Account' />
          </div>
        }

        <div className={'cartIcon mobile1024'} onClick={() => this.userNav('checkout/cart')}>
          <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/header/cart.svg' alt='Shopping cart' />
          {this.state.cartCount ?
            <div className='cartBubble'><div>{this.state.cartCount}</div></div> :
            null
          }
        </div>
        <div className={this.state.searchOpen ? 'open iconSearchWrapper' : 'iconSearchWrapper'}>
          <div className='iconSearch'>
            <div className='inputWrapper'>
              <input type='text' onChange={::this.changeSearch} onKeyPress={::this.keyPressSearch} placeholder='Search Diamonds Direct' />
            </div>
            <div className='actionWrapper' onClick={::this.submitSearch}>
              <i className="fas fa-search"></i>
            </div>
          </div>
        </div>
      </div>
      <div className='earringEventBanner' id='blackFridaySliverBanner' ref={(div) => { this.firstSliver = div; }}>
        <span style={{color: '#FFFFFF', textDecoration: 'none'}} onClick={::this.openIntercom}>
          <div className='desktopMessage'>
            More inventory is available in our showrooms. <span style={{textDecoration: 'underline', fontWeight: '700', marginLeft: '8px'}}>Chat for details!</span>
          </div>
          <div className='mobileMessage'>
            More inventory is available in our showrooms. <span style={{textDecoration: 'underline', fontWeight: '700', marginLeft: '8px'}}>Chat for details!</span>
          </div>
        </span>
      </div>
      <div className='earringEventBanner' id='blackFridaySliverBanner2' ref={(div) => { this.secondSliver = div; }}>
        <div className='desktopMessage'>
          Due to Hurricane Ida, our New Orleans showroom is closed. We are still available to help! See below.
        </div>
        <div className='mobileMessage'>
          Due to Hurricane Ida, our New Orleans showroom is closed. We are still available to help!
        </div>
      </div>
    </div>
  }
}
export default Header;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    common: state.common,
    header: state.header,
  };
}

export const HeaderContainer = connect(
  mapStateToProps,
  allActionCreators
)(Header);


// WEBPACK FOOTER //
// ./src/components/views/header/Header.jsx